import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import componentStyles from './location-list.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class LocationList extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * array of <hf-location-cards /> data
       */
      cards: { type: Array },
      /**
       * a closure function that initialize with an item id
       */
      onViewMap: { type: Function },
    };
  }

  constructor() {
    super();
    this.cards = [];
  }

  render() {
    return html`
      <div class="location-list__card-container">
        ${this.cards &&
        this.cards.map(
          card => html` <hf-location-card
            cardType="list"
            number="${card.number}"
            imageAlt="${card.imageAlt}"
            imageSrc="${card.imageSrc}"
            addressLink="${card.addressLink}"
            addressLine1="${card.addressLine1}"
            addressLine2="${card.addressLine2}"
            addressText="${card.addressText}"
            phoneNumber="${card.phoneNumber}"
            phoneText="${card.phoneText}"
            locationUrl="${card.locationUrl}"
            title="${card.title}"
            detailsLink="${card.detailsLink}"
            id="${card.id}"
            .location="${ifDefined(card.location)}"
            .onViewMap="${ifDefined(this.onViewMap)}"
            class="location-list__card"
          ></hf-location-card>`
        )}
      </div>
    `;
  }
}

customElements.define('hf-location-list', LocationList);
